module.exports = __webpack_public_path__ + "img/master.69392fad.svg";